import { getMeetingDevice, logOff } from '../services/top';
import { onMessage } from '../services/message';
import openDialog from '../components/commons/ScheduleDialog';
import PromptInfo from '../utils/promptInfo.js';
import { PATH_HOME, SEMICOLON } from '../utils/constants';
import { routerRedux } from 'dva/router';

const DialogType = PromptInfo.DialogType;

export default {
  namespace: 'top',
  state: {
    searchInfo: { startTime: Date.now(), endTime: Date.now() },
    devicesList: [],
    meetingSearchInfo: {
      peopleNum: 1,
      meetingType: undefined,
      meetingDevice: undefined,
      moreMeeting: [],
      moreZones: [],
      roomName: ''
    },
    message: { HANDEL: {}, TEXT: {} }
  },
  reducers: {
    setDeviceList(state, { devicesList }) {
      return { ...state, devicesList };
    },
    setMeetingSearchInfo(state, { meetingSearchInfo }) {
      return { ...state, meetingSearchInfo };
    },
    setMessage(state, { message }) {
      return { ...state, message };
    }
  },
  effects: {
    *getMeetingDeviceList({}, { select, put, call }) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      const domainName = sessionStorage.getItem('domainName');
      const data = yield call(getMeetingDevice, { token, locale, domainName });
      yield put({ type: 'setDeviceList', devicesList: data.data });
    },
    *logOff({}, { call, put, select }) {
      const { token } = yield select(state => state.login);
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (window.sok) {
        window.sok.close();
      }
      if (token && userInfo && userInfo.roleId !== 0) {
        // 非实施人员登出时才发送logout请求
        yield call(logOff, { token });
      }
      sessionStorage.clear();
      yield put({ type: 'login/clear' });
      yield put(routerRedux.replace(PATH_HOME));
    },
    *onMessage(
      {
        payload: { message, method, type, state }
      },
      { call, select, put }
    ) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      const res = yield call(onMessage, { message, locale, token, method });
      // validToken(res, getState().i18nReducer.locale);
      if (res.status === 0) {
        if (type) {
          yield put({
            type: 'message/getApprovalList',
            payload: { type, state }
          });
        } else {
          yield put({ type: 'message/getMessageList' });
        }
      } else {
        yield call(openDialog, {
          type: res.status === 2 ? DialogType.WARN : DialogType.ERROR,
          message: res.msg,
          locale: locale
        });
        if (res.status === 1) {
          yield put({
            type: 'message/getApprovalList',
            payload: { type, state }
          });
        }
      }
    },
    *initMeetingSearchInfo(_, { select, put }) {
      const { userInfo } = yield select(state => state.login);
      const { commonZoneIds } = userInfo;
      const meetingSearchInfo = {
        peopleNum: 1,
        meetingType: undefined,
        meetingDevice: undefined,
        moreMeeting: [],
        moreZones: commonZoneIds.split(SEMICOLON),
        roomName: ''
      };
      yield put({
        type: 'setMeetingSearchInfo',
        meetingSearchInfo
      });
    }
  },
  subscriptions: {
    set({ history }) {
      return history.listen(() => {
        return false; //首次加载的问题
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/top.js